/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


















// const GIFT_VARIANT_ID = 45012286341387;
// const GIFT_THRESHOLD = 15000;

// async function checkAndUpdateGift() {
//   try {
//     const cart = await fetch('/cart.js').then(res => res.json());
//     const giftItem = cart.items.find(item => item.variant_id === GIFT_VARIANT_ID);

//     if (cart.total_price >= GIFT_THRESHOLD && !giftItem) {
//       await fetch('/cart/add.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ id: GIFT_VARIANT_ID, quantity: 1 })
//       });
//       console.log("Gift added (cart ≥ €150)");
//       await refreshCartUI(true);
//     } 
//     else if (cart.total_price < GIFT_THRESHOLD && giftItem) {
//       await fetch('/cart/change.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ id: giftItem.key, quantity: 0 }) 
//       });
//       console.log("Gift removed (cart < €150)");
//       await refreshCartUI(true);
//     }
//   } catch (error) {
//     console.error("Error updating gift:", error);
//   }
// }

// async function refreshCartUI(forceFullRefresh = false) {
 
//   if (typeof Shopify === 'object' && Shopify.onCartUpdated) {
//     Shopify.onCartUpdated();
//   }
  
//   document.dispatchEvent(new CustomEvent('cart:updated'));
  
//   if (typeof jQuery !== 'undefined') {
//     jQuery(document).trigger('cart:updated');
//   }

  
//   try {
//     const cart = await fetch('/cart.js').then(res => res.json());
    
    
//     updateCartCount(cart.item_count);
    
    
//     if (forceFullRefresh || isCartDrawerOpen()) {
//       await updateCartItems(cart);
//     }
//   } catch (error) {
//     console.error("Error refreshing cart UI:", error);
//   }
// }

// function isCartDrawerOpen() {
//   const cartDrawer = document.querySelector('.Drawer__Container');
//   return cartDrawer && window.getComputedStyle(cartDrawer).display !== 'none';
// }

// function updateCartCount(count) {
//   const cartCountElements = document.querySelectorAll('.Header__CartCount, .cart-count');
//   cartCountElements.forEach(el => {
//     el.textContent = count || 0;
//   });
// }

// async function updateCartItems(cart) {
//   const cartContainer = document.querySelector('.Cart__ItemList');
//   if (!cartContainer) return;

  
//   let itemsHTML = '';
//   cart.items.forEach((item, index) => {
//     const line = index + 1;
//     itemsHTML += `
//       <div data-line="${line}" data_pplr_row="${line}" class="CartItemWrapper">
//         <div class="CartItem">
//           <div class="CartItem__ImageWrapper AspectRatio">
//             <div class="AspectRatio" style="--aspect-ratio: 0.8">
//               <img class="CartItem__Image" src="${item.image}" alt="${item.title}">
//             </div>
//           </div>

//           <div class="CartItem__Info">
//             <h2 class="CartItem__Title Heading">
//               <a href="${item.url}">${item.title}</a>
//             </h2>

//             <div class="CartItem__Meta Heading Text--subdued">
//               <div class="CartItem__PriceList">
//                 <span class="CartItem__Price Price">
//                   <span class="pplr_item_final_price" data-line="${index}">${formatMoney(item.final_line_price)}</span>
//                 </span>
//               </div>
//             </div>

//             <div class="CartItem__Actions Heading Text--subdued" style="text-align: center">
//               <div class="CartItem__QuantitySelector">
//                 <div class="QuantitySelector">
//                   <a class="QuantitySelector__Button Link Link--primary" 
//                      title="Set quantity to ${item.quantity - 1}" 
//                      href="/cart/change?quantity=${item.quantity - 1}&line=${line}" 
//                      data-quantity="${item.quantity - 1}" 
//                      data-line="${line}" 
//                      data-action="update-item-quantity">
//                     <svg class="Icon Icon--minus" role="presentation" viewBox="0 0 16 2">
//                       <path d="M1,1 L15,1" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path>
//                     </svg>
//                   </a>

//                   <input type="text" name="updates[]" id="updates_${item.variant_id}" 
//                          class="QuantitySelector__CurrentQuantity" 
//                          pattern="[0-9]*" 
//                          data-line="${line}" 
//                          value="${item.quantity}">

//                   <a class="QuantitySelector__Button Link Link--primary" 
//                      title="Set quantity to ${item.quantity + 1}" 
//                      href="/cart/change?quantity=${item.quantity + 1}&line=${line}" 
//                      data-quantity="${item.quantity + 1}" 
//                      data-line="${line}" 
//                      data-action="update-item-quantity">
//                     <svg class="Icon Icon--plus" role="presentation" viewBox="0 0 16 16">
//                       <g stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square">
//                         <path d="M8,1 L8,15"></path>
//                         <path d="M1,8 L15,8"></path>
//                       </g>
//                     </svg>
//                   </a>
//                 </div>
//               </div>

//               <a href="/cart/change?quantity=0&line=${line}" 
//                  class="CartItem__Remove Link Link--underline Link--underlineShort" 
//                  data-quantity="0" 
//                  data-line="${line}" 
//                  data-action="remove-item">Remove</a>
//             </div>
//           </div>
//         </div>
//       </div>
//     `;
//   });

 
//   cartContainer.innerHTML = itemsHTML;

 
//   attachCartEventListeners();
// }

// function formatMoney(price) {
  
//   return (price / 100).toFixed(2) + ' €';
// }

// function attachCartEventListeners() {

//   document.querySelectorAll('[data-action="update-item-quantity"], [data-action="remove-item"]').forEach(button => {
//     button.addEventListener('click', async (e) => {
//       e.preventDefault();
//       await fetch(e.target.getAttribute('href'));
//       await refreshCartUI(true);
//     });
//   });
// }


// document.addEventListener('DOMContentLoaded', () => {
//   checkAndUpdateGift();
//   attachCartEventListeners();
// });


// document.addEventListener('ajaxCart:updated', checkAndUpdateGift);
// document.addEventListener('cart:updated', checkAndUpdateGift);
// document.addEventListener('cart:refresh', () => {
//   checkAndUpdateGift();
//   refreshCartUI();
// });


// let cartChangeInterval;

// function startPolling() {
//   cartChangeInterval = setInterval(checkAndUpdateGift, 1000);
// }

// function stopPolling() {
//   clearInterval(cartChangeInterval);
// }

// document.addEventListener('visibilitychange', () => {
//   if (document.hidden) {
//     stopPolling();
//   } else {
//     startPolling();
//     checkAndUpdateGift();
//   }
// });

// startPolling();










const GIFT_VARIANT_ID = 45012286341387;
const GIFT_THRESHOLD = 15000;

async function checkAndUpdateGift() {
  try {
    const cart = await fetch('/cart.js').then(res => res.json());
    const giftItem = cart.items.find(item => item.variant_id === GIFT_VARIANT_ID);

    if (cart.total_price >= GIFT_THRESHOLD && !giftItem) {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: GIFT_VARIANT_ID, quantity: 1 })
      });
      console.log("Gift added (cart ≥ €150)");
      await refreshCartUI(true);
    } 
    else if (cart.total_price < GIFT_THRESHOLD && giftItem) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: giftItem.key, quantity: 0 }) 
      });
      console.log("Gift removed (cart < €150)");
      await refreshCartUI(true);
    }
  } catch (error) {
    console.error("Error updating gift:", error);
  }
}

async function refreshCartUI(forceFullRefresh = false) {
 
  if (typeof Shopify === 'object' && Shopify.onCartUpdated) {
    Shopify.onCartUpdated();
  }
  
  document.dispatchEvent(new CustomEvent('cart:updated'));
  
  if (typeof jQuery !== 'undefined') {
    jQuery(document).trigger('cart:updated');
  }

  
  try {
    const cart = await fetch('/cart.js').then(res => res.json());
    
    
    updateCartCount(cart.item_count);
    
    
    if (forceFullRefresh || isCartDrawerOpen()) {
      await updateCartItems(cart);
    }
  } catch (error) {
    console.error("Error refreshing cart UI:", error);
  }
}

function isCartDrawerOpen() {
  const cartDrawer = document.querySelector('.Drawer__Container');
  return cartDrawer && window.getComputedStyle(cartDrawer).display !== 'none';
}

function updateCartCount(count) {
  const cartCountElements = document.querySelectorAll('.Header__CartCount, .cart-count');
  cartCountElements.forEach(el => {
    el.textContent = count || 0;
  });
}

async function updateCartItems(cart) {
  const cartContainer = document.querySelector('.Cart__ItemList');
  if (!cartContainer) return;

  let itemsHTML = '';
  cart.items.forEach((item, index) => {
    const line = index + 1;
    const isGift = item.variant_id === GIFT_VARIANT_ID;

    itemsHTML += `
      <div data-line="${line}" data_pplr_row="${line}" class="CartItemWrapper">
        <div class="CartItem">
          <div class="CartItem__ImageWrapper AspectRatio">
            <div class="AspectRatio" style="--aspect-ratio: 0.8">
              <img class="CartItem__Image" src="${item.image}" alt="${item.title}">
            </div>
          </div>

          <div class="CartItem__Info">
            <h2 class="CartItem__Title Heading">
              <a href="${item.url}">${item.title}</a>
            </h2>

            <div class="CartItem__Meta Heading Text--subdued">
              <div class="CartItem__PriceList">
                <span class="CartItem__Price Price">
                  <span class="pplr_item_final_price" data-line="${index}">${formatMoney(item.final_line_price)}</span>
                </span>
              </div>
            </div>

            <div class="CartItem__Actions Heading Text--subdued" style="text-align: center">
              ${isGift ? '' : `
                <div class="CartItem__QuantitySelector">
                  <div class="QuantitySelector">
                    <a class="QuantitySelector__Button Link Link--primary" 
                       title="Set quantity to ${item.quantity - 1}" 
                       href="/cart/change?quantity=${item.quantity - 1}&line=${line}" 
                       data-quantity="${item.quantity - 1}" 
                       data-line="${line}" 
                       data-action="update-item-quantity">
                      <svg class="Icon Icon--minus" role="presentation" viewBox="0 0 16 2">
                        <path d="M1,1 L15,1" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path>
                      </svg>
                    </a>

                    <input type="text" name="updates[]" id="updates_${item.variant_id}" 
                           class="QuantitySelector__CurrentQuantity" 
                           pattern="[0-9]*" 
                           data-line="${line}" 
                           value="${item.quantity}">

                    <a class="QuantitySelector__Button Link Link--primary" 
                       title="Set quantity to ${item.quantity + 1}" 
                       href="/cart/change?quantity=${item.quantity + 1}&line=${line}" 
                       data-quantity="${item.quantity + 1}" 
                       data-line="${line}" 
                       data-action="update-item-quantity">
                      <svg class="Icon Icon--plus" role="presentation" viewBox="0 0 16 16">
                        <g stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square">
                          <path d="M8,1 L8,15"></path>
                          <path d="M1,8 L15,8"></path>
                        </g>
                      </svg>
                    </a>
                  </div>
                </div>
              `}

              ${isGift ? '' : `
                <a href="/cart/change?quantity=0&line=${line}" 
                   class="CartItem__Remove Link Link--underline Link--underlineShort" 
                   data-quantity="0" 
                   data-line="${line}" 
                   data-action="remove-item">Remove</a>
              `}
            </div>
          </div>
        </div>
      </div>
    `;
  });

  cartContainer.innerHTML = itemsHTML;
  attachCartEventListeners();
}

function formatMoney(price) {
  
  return (price / 100).toFixed(2) + ' €';
}

function attachCartEventListeners() {

  document.querySelectorAll('[data-action="update-item-quantity"], [data-action="remove-item"]').forEach(button => {
    button.addEventListener('click', async (e) => {
      e.preventDefault();
      await fetch(e.target.getAttribute('href'));
      await refreshCartUI(true);
    });
  });
}


document.addEventListener('DOMContentLoaded', () => {
  checkAndUpdateGift();
  attachCartEventListeners();
});


document.addEventListener('ajaxCart:updated', checkAndUpdateGift);
document.addEventListener('cart:updated', checkAndUpdateGift);
document.addEventListener('cart:refresh', () => {
  checkAndUpdateGift();
  refreshCartUI();
});


let cartChangeInterval;

function startPolling() {
  cartChangeInterval = setInterval(checkAndUpdateGift, 1000);
}

function stopPolling() {
  clearInterval(cartChangeInterval);
}

document.addEventListener('visibilitychange', () => {
  if (document.hidden) {
    stopPolling();
  } else {
    startPolling();
    checkAndUpdateGift();
  }
});

startPolling();












